import Cookies from "js-cookie"

function currHost() {
  return document.location.hostname.endsWith("hult.edu")
    ? ".hult.edu"
    : document.location.hostname
}

const attributionCookies = {
  //   _source: "utm_source",
  _medium: "utm_medium",
  _campaign: "utm_campaign",
  _term: "utm_term",
  _content: "utm_content",
  _referrer: "event.page_referrer",
  _entry: "event.page_location",
}

const firstAttributionCookies = {
  //   _first_source: "utm_source",
  _first_medium: "utm_medium",
  _first_campaign: "utm_campaign",
  _first_term: "utm_term",
  _first_content: "utm_content",
  _first_referrer: "event.page_referrer",
  _first_entry: "event.page_location",
}

const hultIds = {
  _mcJobId: "j",
  _sfmc_id: "sfmc_id",
  _sfc_id: "s",
  _gclid: "gclid",
  _fbclid: "fbclid",
}

const atributionControlCookie = "_source"
const firstTouchAtributionControlCookie = "_first_source"
const firstTouchReferralCookie = "_first_referral"
const firstTouchEntryCookie = "_first_entry"

const atributionControlParam = "utm_source"
const atributionControlDefaultValue = "none"

export function attributionCookiesBackup(): void {
  const controlCookie = Cookies.get(atributionControlCookie)
  const firstControlCookie = Cookies.get(firstTouchAtributionControlCookie)

  if (document && !(controlCookie && firstControlCookie)) {
    const cookieOptions = {
      domain: currHost(),
      path: "/",
      secure: true,
      expires: 30,
    }

    const pageLocation = document.location
    const pageReferrer = document.referrer

    const eventData = {
      page_location: pageLocation.href,
      page_referrer: pageReferrer,
    }

    const searchParamsObj = new URLSearchParams(pageLocation.search)

    const controlCookie = Cookies.get(atributionControlCookie)
    const firstControlCookie = Cookies.get(firstTouchAtributionControlCookie)

    const firstReferrerCookie = Cookies.get(firstTouchReferralCookie)
    const firstEntryCookie = Cookies.get(firstTouchEntryCookie)

    const searchParams: { [key: string]: string } = {}
    for (const [key, value] of searchParamsObj.entries()) {
      searchParams[key.toLowerCase()] = value
    }

    let isDirect = !searchParams[atributionControlParam]
    if (isDirect && pageReferrer) {
      const referrerUrlObj = new URL(pageReferrer)
      isDirect = referrerUrlObj.hostname.indexOf(".hult.edu") > -1
    }

    let isFirstDirect =
      !firstControlCookie ||
      firstControlCookie === atributionControlDefaultValue
    if (isFirstDirect && firstEntryCookie && firstReferrerCookie) {
      const firstReferrerUrlObj = new URL(firstReferrerCookie)
      isFirstDirect = firstReferrerUrlObj.hostname.indexOf(".hult.edu") > -1
    }

    // Attribution Cookies
    if (searchParams[atributionControlParam] || !isDirect || !controlCookie) {
      Cookies.set(
        atributionControlCookie,
        searchParams[atributionControlParam] || atributionControlDefaultValue,
        cookieOptions
      )

      for (const [key, value] of Object.entries(attributionCookies)) {
        if (value.indexOf("event.") > -1) {
          const eventParam = value.split(".")[1] as
            | "page_location"
            | "page_referrer"
          Cookies.set(key, eventData[eventParam] || "", cookieOptions)
        } else {
          Cookies.set(key, searchParams[value] || "", cookieOptions)
        }
      }
    }

    // First Touch Attribution Cookies
    if (
      (!firstControlCookie || isFirstDirect) &&
      (searchParams[atributionControlParam] || !isDirect || !firstControlCookie)
    ) {
      Cookies.set(
        firstTouchAtributionControlCookie,
        searchParams[atributionControlParam] || atributionControlDefaultValue,
        cookieOptions
      )

      for (const [key, value] of Object.entries(firstAttributionCookies)) {
        if (value.indexOf("event.") > -1) {
          const eventParam = value.split(".")[1] as
            | "page_location"
            | "page_referrer"
          Cookies.set(key, eventData[eventParam] || "", cookieOptions)
        } else {
          Cookies.set(key, searchParams[value] || "", cookieOptions)
        }
      }
    }

    // Hult IDs Cookies
    for (const [key, value] of Object.entries(hultIds)) {
      if (searchParams[value]) {
        Cookies.set(key, searchParams[value] || "", cookieOptions)
      }
    }
  }
}
